import { Pagination } from "../Pagination";
import { useTableContext } from "./context";
import { RowDensity } from "./RowDensity";
import { Selection } from "./Selection";

export function TableFooter() {
  const { pagination, selection, footerAccessory } = useTableContext();

  const hasSelection =
    selection && (selection.selectAll || selection.selectedItems.length > 0);

  if (!pagination && !hasSelection && !footerAccessory) {
    return null;
  }

  return (
    <div className="h-16 px-4 flex shrink-0 items-center gap-6 border-t border-neutral-500/5">
      <div className="flex items-center gap-4">
        <Selection />
        {footerAccessory}
      </div>
      {pagination && (
        <div className="flex-1 flex justify-end">
          <Pagination {...pagination} />
        </div>
      )}
      <RowDensity />
    </div>
  );
}
